import BetterFloatingInput from './BetterFloatingInput'

export default BetterFloatingInput
